"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAUNCHDARKLY_USERID = exports.FEATURE_FLAG = void 0;
exports.FEATURE_FLAG = {
    cookieName: "_bh_ffs",
};
exports.LAUNCHDARKLY_USERID = {
    cookieName: "_bh_lduid",
    expires: 63072000000, // 2 years in ms
};
//# sourceMappingURL=constants.js.map